var t = /* @__PURE__ */function (T) {
    return T.HORIZONTAL = "row", T.VERTICAL = "column", T;
  }(t || {}),
  o = /* @__PURE__ */function (T) {
    return T.CENTER = "center", T.LEFT = "left", T.RIGHT = "right", T;
  }(o || {}),
  E = /* @__PURE__ */function (T) {
    return T.BOTTOM = "bottom", T.TOP = "top", T.MIDDLE = "middle", T;
  }(E || {});
export { o as E, E as O, t as T };